import { Component, OnInit, NgZone, HostListener } from '@angular/core';
import { TranslationService } from './shared/services/translation.service';
import * as moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  constructor(
    private translateService: TranslationService
  ) {

    // const lang = localStorage.getItem('language') || 'en';
    // if (lang == "ar") {
    //   moment.updateLocale("ar",{
    //     months :["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"]})
    // }
  }

  ngOnInit() {
    this.setLnag();
  }

  setLnag() {
    const lang = this.translateService.getSelectedLanguage();
    this.translateService.setLanguage(lang);
  }

  removeTags(str: any) {
    if (str === null || str === '') {
      return false;
    } else {
      str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, '');
    }
  }
}
